<template>
  <v-toolbar class="theme--dark main-navigation-bar">
    <div class="logo-container">
      <!-- <img
        class="login-logo"
        src="../../assets/images/uplabdh_logo_clear.png"
        style="cursor: pointer"
        @click="goToRoot"
      /> -->

      <!-- <div class="br-line hidden-sm-and-down" /> -->
      <img
        class="login-logo hidden-sm-and-down"
        src="../../assets/images/Emblem_of_India.png"
      />

      <div class="hidden-sm-and-down" style="margin-left: 0.9375em">
        <div
          style="font-size: 1.125em; color: #e95903; font-weight: bold; white-space: nowrap;"
        ></div>
        <div style="color: #4b4b4b; white-space: nowrap;">
          Government of Arunachal Pradesh
        </div>
      </div>
    </div>

    <v-spacer />

    <template v-if="loggedIn">
      <!-- Notification -->
      <Notification />

      <!-- Navigation -->
      <Navigation />

      <div style="width: 0.625em"></div>

      <!-- Avatar -->
      <v-menu :close-on-content-click="false" :nudge-width="240" offset-y>
        <!-- Avatar -->
        <template v-slot:activator="{ on }">
          <Avatar
            :url="currentUser.avatar"
            :name="currentUser.name"
            size="1.65em"
            class="touchable-highlight"
            v-on="on"
          />
        </template>

        <!-- Info -->
        <v-card style="min-width: 12.5em">
          <v-card-text style="text-align: center">
            <Avatar
              :url="currentUser.avatar"
              :name="currentUser.name"
              size="2em"
            />

            <div class="mt-2 font-weight-bold">
              {{ currentUser.name }}
            </div>
            <div>
              {{ currentUser.email }}
            </div>
            <div class="mt-2">Utility v{{ appVersion }}</div>
          </v-card-text>

          <v-card-actions>
            <v-btn flat small @click="goToProfile">
              <v-icon class="mr-1" dark>settings</v-icon>
              Settings
            </v-btn>
            <v-spacer />
            <LogoutLink flat small type="button" />
          </v-card-actions>
        </v-card>
      </v-menu>
    </template>

    <template v-else>
      <v-btn dark flat :to="`/login`">Log In</v-btn>
    </template>
  </v-toolbar>
</template>

<script>
import LogoutLink from "./LogoutLink";
import { mapGetters, mapState } from "vuex";
import Notification from "./Notification";
import Navigation from "./Navigation/Navigation";
import Avatar from "@/components/Avatar";

export default {
  components: {
    Notification,
    LogoutLink,
    Navigation,
    Avatar
  },

  data() {
    return {
      model: "/dashboard"
    };
  },

  computed: {
    ...mapState("auth", ["currentUser"]),

    ...mapGetters("auth", ["loggedIn"]),

    appVersion() {
      return window.config.VERSION;
    }
  },

  methods: {
    goToProfile() {
      this.$router.push({ name: "profile" });
    },

    goToRoot() {
      this.$router.push({ name: "landing-page" });
    }
  }
};
</script>

<style lang="css" scoped>
.br-line {
  width: 0.0625em;
  height: 95%;
  margin: 0.9375em;
  background: #4b4b4b;
}

.logo-container {
  display: inline-flex;
  align-items: center;
  flex: 1;
  height: 100%;
}

.menu-btn {
  height: 3.125em;
  background-color: #fafbfd;
  margin: 0em 0.0625em !important;
}

.nav-bar-container {
  width: 100%;
  background-color: #272e3a;
  padding: 0.9375em 1.25em 0;
}

.btn-groups {
  overflow-y: hidden;
  overflow-x: auto;
}

.btn-groups-active {
  background-color: #62637d !important;
  color: white !important;
  opacity: 1;
}

.login-logo {
  height: 3.125em;
}

.main-navigation-bar {
  background: linear-gradient(
    90deg,
    rgba(235, 235, 255, 1) 0%,
    rgba(99, 100, 126, 1) 80%
  );
}
</style>
